import { render, staticRenderFns } from "./ofaccommercial.vue?vue&type=template&id=038d4e22"
import script from "./ofaccommercial.vue?vue&type=script&lang=js"
export * from "./ofaccommercial.vue?vue&type=script&lang=js"
import style0 from "./ofaccommercial.vue?vue&type=style&index=0&id=038d4e22&prod&lang=scss&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports